export default __webpack_public_path__ + "static/article-surviving-the-boxing-day-sales-4e0af9a8653c138b6c37be18e0e522d1.jpg";